export default "__VITE_ASSET__fff87993__"